import { Link, useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Sparkles, XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <Link to="/" className="flex items-center justify-center gap-2 mb-8">
          <span className="grid h-9 w-9 place-items-center rounded-lg bg-blue-600 text-white">
            <Sparkles className="h-4 w-4" />
          </span>
          <span className="font-jakarta text-xl font-bold text-slate-900">AlternAI</span>
        </Link>
        <Card className="p-8 rounded-2xl border-slate-200 bg-white text-center" data-testid="payment-cancel-card">
          <div className="mx-auto grid h-14 w-14 place-items-center rounded-full bg-slate-100 text-slate-500">
            <XCircle className="h-6 w-6" />
          </div>
          <h1 className="mt-4 font-jakarta text-xl font-bold text-slate-900">Paiement annulé</h1>
          <p className="mt-2 text-sm text-slate-500">Aucun montant n'a été prélevé. Tu peux réessayer à tout moment.</p>
          <Button onClick={() => navigate("/dashboard")} className="mt-6 w-full h-11 bg-blue-600 hover:bg-blue-700 rounded-full" data-testid="payment-cancel-cta">
            Retour au dashboard
          </Button>
        </Card>
      </div>
    </div>
  );
}
